import React, { useState } from "react";
import { Col, Form, Row, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import TableTemp from "../../../Components/TableTemplate/Table";
import {
  numberFormat,
  refreshPage,
  toastStyle,
  getType,
  getTodayDateISO,
} from "../../../Helpers/Utils/Common";
import { CSVLink } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import ViewModal from "../../../Components/Modals/ViewModal";
import {
  searchOrder,
  updateVoidRequest,
} from "../../../Helpers/apiCalls/Reports/DailyOrdersApi";
import Footer from "../../../Components/Footer/Footer";

export default function ViewDailyExpenses() {
  const { id, priceLevelId, date, shop } = useParams();
  const { state } = useLocation();
  let navigate = useNavigate();
  const accountType = getType();
  const [inactive, setInactive] = useState(true);
  const [filterConfig, setFilterConfig] = useState({
    branch_id: state?.branch_id,
    date_from: state?.date ? new Date(state.date) : "",
    date_to: state?.date ? new Date(state.date) : "",
    group_orders: "false",
    group_by_date: "1",
    status: state?.status ? state.status : "",
  });
  //
  const [showLoader, setShowLoader] = useState(false);
  const [sales, setSales] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [branchName, setBranchName] = useState("");
  const [totalSales, settotalSales] = useState("");
  const [finalTotalSales, setFinalTotalSales] = useState("");
  const [totalOrder, setTotalOrder] = useState("");
  const [averageOrderValue, setAverageOrderValue] = useState("");

  // VIEW
  const [showViewModal, setShowViewModal] = useState(false);
  const handleShowViewModal = () => setShowViewModal(true);
  const handleCloseViewModal = () => setShowViewModal(false);

  const [showVoidModal, setShowVoidModal] = useState(false);
  const handleShowVoidModal = () => setShowVoidModal(true);
  const handleCloseVoidModal = () => setShowVoidModal(false);


  const excelHeaders = [
    { label: "ORDER NO.", key: "id" },
    { label: "TRAN. METHOD", key: "transaction_type" },
    { label: "TRAN. REF NO.", key: "tran_ref_no_export" },
    { label: "PIECES", key: "qty" },
    { label: "SYSTEM TOTAL", key: "subtotal" },
    { label: "FINAL TOTAL", key: "final_total" },
    { label: "PAY METHOD", key: "payment_type" },
    { label: "PMT REF NO.", key: "pay_ref_no_export" },
    { label: "TIME", key: "time" },
    { label: "STATUS", key: "status" },
    { label: "REMARKS", key: "remarks" },
    { label: "APPROVED BY", key: "approved_by_name" },
  ];

  function handleSelectChange(e, row) {
    setSelectedRow(row);

    if (e.target.value === "void") {
      handleShowVoidModal();
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
        {accountType === "admin" && row.status === "request_to_void" ? (
          <option value="void" className="color-options">
            Request to Void
          </option>
        ) : (
          <option value="" disabled className="color-options">
            No action
          </option>
        )}
      </Form.Select>
    );
  }

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  }

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={() => handlePrint(row)}
      >
        View
      </button>
    );
  }
  function handlePrint(row) {
    //
    
    var allBills = row;
    allBills.order_detail = allBills.order_detail?.map((data) => {
      var info = data;
      info.addOnPrices = data.product_detail?.map((item) => {
        return parseFloat(item.qty) * parseFloat(item.price);
      });
      info.addOnTotal = info.addOnPrices.reduce(
        (a, b) => parseFloat(a) + parseFloat(b),
        0
      );
      info.priceWithAddOn = parseFloat(data.price) + info.addOnTotal;
      return info;
    });
    setSelectedRow(row);
    handleShowViewModal();
  }

  async function fetchData() {
    setShowLoader(true);
    setSales([]);
    const response = await searchOrder(filterConfig);
    if (response.error) {
      setBranchName(state?.branch_name ? state?.branch_name : branchName);
      setTotalOrder("0");
      setAverageOrderValue("0");
    } else {
      setBranchName(response.data.data[0]?.branch_name);
      var allBills = response.data.data.map((bill, index) => {
        var paytype = bill.payment[0]?.payment_type.split("_");
        var info = bill;
        info.amount = numberFormat(bill.subtotal);
        info.transaction_type = bill.transaction_type;
        info.qty = bill.order_detail
          ?.map((item) => item.qty)
          .reduce((a, b) => parseInt(a) + parseInt(b), 0);
        info.amount = bill.order_detail
          ?.map((item) => item.subtotal)
          .reduce((a, b) => parseInt(a) + parseInt(b), 0);

        info.subtotal = bill.payment[0]?.subtotal;
        info.final_total = bill.payment[0]?.final_total;
        info.discount_description = bill.payment[0]?.discount_description
          ? bill.payment[0]?.discount_description
          : "";
        info.active_discount = numberFormat(
          parseFloat(bill.payment[0]?.discount) +
            parseFloat(bill.payment[0]?.merchant_discount_share)
        );
        info.total_discount = numberFormat(
          parseFloat(bill.payment[0]?.discount) +
            parseFloat(bill.payment[0]?.merchant_discount_share) +
            parseFloat(bill.payment[0]?.additional_discounts)
        );
        info.discount = numberFormat(bill.payment[0]?.discount);
        info.merchant_discount_share = numberFormat(
          bill.payment[0]?.merchant_discount_share
        );
        info.additional_discounts = numberFormat(
          bill.payment[0]?.additional_discounts
        );
        info.computed_grand_total = numberFormat(
          parseFloat(bill.grand_total) -
            parseFloat(bill.discount) +
            parseFloat(bill.payment[0]?.delivery_fee)
        );
        info.delivery_fee = numberFormat(bill.payment[0]?.delivery_fee);
        info.grand_total = numberFormat(bill.grand_total);
        info.grand_total_table = numberFormat(bill.payment[0]?.grand_total);
        info.paid_amount = numberFormat(bill.paid_amount);
        info.payment_type =
          paytype.length < 2
            ? bill.payment[0]?.payment_type
            : paytype[0] + " " + paytype[1];
        info.pay_ref_no = bill.payment[0]?.reference_no;
        info.pay_ref_no_export = '=""' + bill.payment[0]?.reference_no + '""';
        info.tran_ref_no = bill.payment[0]?.transaction_no
          ? bill.payment[0]?.transaction_no
          : bill.payment[0]?.reference_no
          ? bill.payment[0]?.reference_no
          : "";
        info.tran_ref_no_export = bill.payment[0]?.transaction_no
          ? '=""' + bill.payment[0]?.transaction_no + '""'
          : bill.payment[0]?.reference_no
          ? '=""' + bill.payment[0]?.reference_no + '""'
          : "";
        info.time = new Date(bill.added_on).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
        return info;
      });
      setSales(allBills);

      var systemtotal = response.data.summary
        ? response.data.summary.total_sales
        : "0";
      var finaltotal = response.data.summary
        ? response.data.summary.final_subtotal
        : "0";
      settotalSales(systemtotal);
      setFinalTotalSales(finaltotal);
      var totalorder = response.data.summary
        ? response.data.summary.total_orders
          ? response.data.summary.total_orders
          : "0"
        : "0";
      var average = response.data.summary
        ? response.data.summary.average_order_value
          ? response.data.summary.average_order_value
          : "0"
        : "0";
      setTotalOrder(totalorder);
      setAverageOrderValue(average);
    }
    setShowLoader(false);
  }

  async function handleUpdateVoidRequest(status) {
    const response = await updateVoidRequest(
      id,
      selectedRow.id,
      status,
      selectedRow.remarks
    );
    if (response.error) {
      toast.error(response.error.response.data.messages.error, {
        style: toastStyle(),
      });
    } else {
      toast.success("Successfully Updated Order Status!", {
        style: toastStyle(),
      });
      setTimeout(() => {
        refreshPage();
      }, 1000);
    }
  }

  function RedText(row) {
    return (
      <span className="me-4 align-middle ps-label red">{row.final_total}</span>
    );
  }

  React.useEffect(() => {
    fetchData();
  }, [filterConfig]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"DS REPORTS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={6}>
            <h1 className="page-title"> {branchName} </h1>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={12} md={6} lg={7}>
            <h5 className="page-subtitle">
              {" "}
              {new Date(date).toLocaleDateString("en-us", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}{" "}
            </h5>
            <h5 className="page-subtitle">
              {" "}
              Total No. of Orders: {totalOrder}
            </h5>
            <h5 className="page-subtitle">
              {" "}
              Average Order Value: {"\u20B1"}
              {numberFormat(averageOrderValue)}
            </h5>
          </Col>
          <Col xs={6} md={3} lg={2} className="d-flex justify-content-end">
            {/* <div> */}
              <button
                name="action"
                className="button-primary justify-content-center align-items-center close-btn p-2"
                onClick={() => navigate("addorder")}
              >
                Add Order
              </button>
            {/* </div> */}
          </Col>
          <Col xs={6} md={3} lg={3} className="">
              {/* <div> */}
              <CSVLink
                className="button-primary justify-content-center align-items-center download-csv p-2"
                data={sales}
                headers={excelHeaders}
                target="_blank"
                filename={`${getTodayDateISO()} Store Deposit`}
              >
                Download Excel
              </CSVLink>
              {/* </div> */}
          </Col>
        </Row>

        <div className="tab-content">
          <div className="my-2 px-2 PO-filters d-flex">
            <span className="me-4 align-middle mt-2 ps-label">Filter By:</span>
            <Form.Select
              name="type"
              className="date-filter me-2"
              onChange={(e) => handleOnSearch(e)}
            >
              <option value="" selected>
                All Types
              </option>
              <option value="store"> Store </option>
              <option value="foodpanda"> Food Panda </option>
              <option value="grabfood"> Grab Food </option>
            </Form.Select>

            <Form.Select
              name="mode"
              className="date-filter me-2"
              onChange={(e) => handleOnSearch(e)}
            >
              <option value="" selected>
                All Modes
              </option>
              <option value="cash"> Cash </option>
              <option value="gcash"> GCash </option>
              <option value="credit"> Credit </option>
              <option value="bank"> Bank </option>
              <option value="gift_certificate"> Gift Certificate </option>
              <option value="others"> Others </option>
            </Form.Select>

            <Form.Select
              name="status"
              className="date-filter me-2"
              onChange={(e) => handleOnSearch(e)}
              value={filterConfig.status}
            >
              <option value="" selected>
                All Status
              </option>
              <option value="approved"> Success </option>
              <option value="voided"> Cancelled </option>
              <option value="request_to_void"> Request To Void </option>
            </Form.Select>
          </div>

          <div className="my-2 px-2 PO-filters d-flex justify-content-center">
            <span className="me-4 ml-4 align-middle mt-2 ps-label">
              System Total Sales: {numberFormat(totalSales)}
            </span>
            <span className="me-4 ml-4 align-middle mt-2 ps-label">
              Final Total Sales: {numberFormat(finalTotalSales)}
            </span>
          </div>

          <div className="below">
            <TableTemp
              tableHeaders={[
                "-",
                "ORDER NO.",
                "TRAN. METHOD",
                "TRAN. REF NO.",
                "PIECES",
                "SYSTEM TOTAL",
                "STORE DIS",
                "SYSTEM W/ DIS",
                "ACTIVE DIS",
                "ADDTL DISCOUNT",
                "DELIVERY FEE",
                "FINAL TOTAL",
                "PAY METHOD",
                "PMT REF NO.",
                "TIME",
                "STATUS",
                "REMARKS",
                "APPROVED BY",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "id",
                "transaction_type",
                "tran_ref_no",
                "qty",
                "subtotal",
                "discount",
                "grand_total_table",
                "active_discount",
                "additional_discounts",
                "delivery_fee",
                "final_total",
                "payment_type",
                "pay_ref_no",
                "time",
                "status",
                "remarks",
                "approved_by_name",
              ]}
              tableData={sales}
              ViewBtn={(row) => ViewBtn(row)}
              ContractBtn={(row) => RedText(row)}
              ActionBtn={(row) => ActionBtn(row)}
              showLoader={showLoader}
            />
          </div>
          <div className="mb-2" />
        </div>

        
        <div className="d-flex justify-content-end pt-2 mb-3">
        <Col xs={4} md={3} lg={4}>
          <button
            name="action"
            className="p-2 button-primary justify-content-center align-items-center close-btn"
            onClick={() => navigate(-1)}
          >
            Close
          </button>
          </Col>
        </div>
       
      </div>

      <ViewModal
        withCloseButtons
        show={showViewModal}
        onHide={handleCloseViewModal}
        size="lg"
      >
        <div className="mt-0">
          <div className="col-sm-12 m-0 space">
            <Row className="custom-modal-body-title-daily-orders w-100">
              <Col xs={3} className="custom-modal-pic-right">
                {/* <img width={50} height={50} src={Smoothie}></img> */}
              </Col>
              <Col xs={6}>
                <Row className="justify-content-center">
                  Order {selectedRow.id}
                </Row>
                <Row className="custom-modal-sub-daily-orders ">
                  {selectedRow.time}
                </Row>
              </Col>
              <Col xs={3} className="custom-modal-pic-left">
                {/* <img width={50} height={50} src={Smoothie}></img> */}
              </Col>
            </Row>
            <Row className="custom-modal-body-title-branch-details-no-pic w-100">
              <Col xs={12} className="justify-content-center">
                {branchName}
              </Col>
            </Row>
          
            <div className="mt-3 ">
              <Row className="nc-modal-custom-row-view">
                <Col xl={9}>
                  <Col className="ms-3">
                    {selectedRow?.order_detail?.length > 0
                      ? selectedRow.order_detail.map((data) => {
                          return (
                            <>
                              <Row className="">
                                {data.product_name}
                              </Row>
                              <Row className="custom-modal-sub-product">
                                PHP {numberFormat(data.price)}
                              </Row>
                              {data.product_detail.length > 0
                                ? data.product_detail.map((prod) => {
                                    return (
                                      <>
                                        <Row className="custom-modal-sub-product">
                                          {"x" +
                                            prod.qty +
                                            " " +
                                            prod.product_name +
                                            " = P" +
                                            prod.price}
                                        </Row>
                                      </>
                                    );
                                  })
                                : ""}
                            </>
                          );
                        })
                      : ""}
                  </Col>
                </Col>
                <Col xl={3}>
                  <Col className="nc-modal-custom-row">
                    {selectedRow?.order_detail?.length > 0
                      ? selectedRow.order_detail.map((data) => {
                          return (
                            <>
                              <Row className="custom-modal-sub-product-yellow justify-content-center">
                                {" "}
                                {data.qty}{" "}
                              </Row>
                              <Row className="justify-content-center">
                                PHP {numberFormat(data.product_total)}
                              </Row>
                              {data.product_detail.length > 0
                                ? data.product_detail.map((prod) => {
                                    return (
                                      <>
                                        <Row className="custom-modal-sub-product-white">
                                          {"-"}
                                        </Row>
                                      </>
                                    );
                                  })
                                : ""}
                            </>
                          );
                        })
                      : ""}
                  </Col>
                </Col>
              </Row>
            </div>
            <br />
            <div className="break"> </div>
            <div className="mt-3 ">
              <Row className="nc-modal-custom-row-view">
                {selectedRow?.payment
                  ? selectedRow?.payment[0]?.discounts?.length > 0 && (
                      <>
                        <Row className="ms-1 me-1">Discount Details</Row>
                        {selectedRow.payment
                          ? selectedRow?.payment[0]?.discounts?.length > 0
                            ? selectedRow?.payment[0]?.discounts.map((data) => {
                                return (
                                  <>
                                    <Row className="ms-1 me-1">
                                      <Col xs={6} className="">
                                        <Row className="custom-modal-sub-product">
                                          {" "}
                                          {data.name}{" "}
                                        </Row>
                                      </Col>
                                      <Col xs={6} className="">
                                        <Row className="custom-modal-sub-product justify-content-end">
                                          {" "}
                                          {data.id_no || "N/A"}{" "}
                                        </Row>
                                      </Col>
                                    </Row>
                                  </>
                                );
                              })
                            : ""
                          : ""}
                      </>
                    )
                  : ""}
                <Col xl={12}>
                  <Row className="ms-1 me-1">
                    <Col xs={6} className="">
                      <Row> Transaction Method </Row>
                      <Row className="custom-modal-sub-product">
                        {" "}
                        Reference No.{" "}
                      </Row>
                    </Col>
                    <Col xs={6} className="">
                      <Row className="justify-content-end">
                        {" "}
                        {selectedRow?.transaction_type}{" "}
                      </Row>
                      <Row className="custom-modal-sub-product justify-content-end">
                        {" "}
                        {selectedRow?.tran_ref_no || "N/A"}{" "}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="ms-1 me-1">
                    <Col xs={6} className="">
                      <Row> Payment Method </Row>
                      <Row className="custom-modal-sub-product">
                        {" "}
                        Reference No.{" "}
                      </Row>
                    </Col>
                    <Col xs={6} className="">
                      <Row className="justify-content-end">
                        {" "}
                        {selectedRow?.payment_type}{" "}
                      </Row>
                      <Row className="custom-modal-sub-product justify-content-end">
                        {" "}
                        {selectedRow?.pay_ref_no || "N/A"}{" "}
                      </Row>
                    </Col>
                  </Row>
                  <div className="break"> </div>
                  <Row className="ms-1 me-1">
                    <Col xs={6} className="">
                      <Row className="bolder system-total"> System Total </Row>
                      <Row> Delivery Fee </Row>
                      <hr />
                      <Row> Active Discount </Row>
                      <Row className="custom-modal-sub-product ms-3">
                        {" "}
                        Discount(MM){" "}
                      </Row>
                      <Row className="custom-modal-sub-product ms-3">
                        {" "}
                        Discount(Merchant){" "}
                      </Row>
                      <Row> Additional Discount </Row>
                      <Row className="custom-modal-sub-product ms-3">
                        {" "}
                        Discount Code{" "}
                      </Row>
                      <Row> Total Discount </Row>
                      <hr />
                      <Row className="bolder system-total"> Grand Total </Row>
                    </Col>
                    <Col xs={6} className="">
                      {/* <Row className="justify-content-end"> PHP {selectedRow?.subtotal} </Row> */}
                      <Row className="justify-content-end bolder system-total">
                        {" "}
                        PHP {selectedRow?.subtotal}{" "}
                      </Row>
                      <Row className="justify-content-end">
                        + PHP {selectedRow?.delivery_fee}{" "}
                      </Row>
                      <hr />
                      <Row className="justify-content-end">
                        {selectedRow?.discount_description +
                          " - " +
                          selectedRow?.active_discount}{" "}
                      </Row>
                      <Row className="justify-content-end custom-modal-sub-product">
                        PHP {selectedRow?.discount}{" "}
                      </Row>
                      <Row className="justify-content-end custom-modal-sub-product">
                        PHP {selectedRow?.merchant_discount_share}{" "}
                      </Row>
                      <Row className="justify-content-end">
                        - PHP {selectedRow?.additional_discounts}{" "}
                      </Row>
                      <Row className="justify-content-end custom-modal-sub-product">
                        {" "}
                        {selectedRow?.discount_code !== ""
                          ? selectedRow?.discount_code
                          : "N/A"}{" "}
                      </Row>
                      <Row className="justify-content-end">
                        - PHP {selectedRow?.total_discount}{" "}
                      </Row>
                      <hr />
                      <Row className="justify-content-end bolder system-total">
                        {" "}
                        PHP {selectedRow?.final_total}{" "}
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>

      <Modal
        show={showVoidModal}
        onHide={() => handleCloseVoidModal()}
        size="lg"
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body className="pt-2">
          <div className="review-container p-3">
            <Row className="nc-modal-custom-row-view">
              <Col xs={6}>
                Order ID
                <Row className="nc-modal-custom-row">
                  <Col>{selectedRow?.id || "N/A"}</Col>
                </Row>
              </Col>
              <Col xs={6}>
                Amount
                <Row className="nc-modal-custom-row">
                  <Col>{selectedRow?.grand_total || "N/A"}</Col>
                </Row>
              </Col>
            </Row>
            <Row className="nc-modal-custom-row-view mt-3">
              <Col xs={12}>
                Remarks
                <Row className="nc-modal-custom-row">
                  <Col>
                    <Form.Control
                      type="text"
                      name="remarks"
                      className="nc-modal-custom-text"
                      value={selectedRow.remarks}
                      onChange={(e) =>
                        setSelectedRow((prev) => {
                          return {
                            ...prev,
                            remarks: e.target.value,
                          };
                        })
                      }
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          {selectedRow.status === "request_to_void" && (
            <>
              <div className="d-flex justify-content-end my-4">
                <button
                  className="button-warning-fill me-2"
                  onClick={() => handleUpdateVoidRequest("reject")}
                >
                  Reject
                </button>
                <button
                  className="button-primary"
                  onClick={() => handleUpdateVoidRequest("approve")}
                >
                  Approve
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
      <Footer/>
    </div>
  );
}
